import type React from "react";

import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import invariant from "ts-invariant";

import { useGetEarningsUsTherapist } from "api/hooks/useGetEarningsUsTherapist";
import { useProfileContext } from "contexts/ProfileContext/useProfileContext";
import { EnrolledPatients } from "routes/dashboard/default/components/shared/EnrolledPatients";
import { getStartOfMonth } from "utils/date";

import { TotalEarnings } from "./TotalEarnings/TotalEarnings";

export const EarningsWidget: React.FC = () => {
  const { t } = useTranslation();
  const { profile } = useProfileContext();

  invariant(profile, "Profile should be defined");

  const { data } = useGetEarningsUsTherapist({
    therapist_id: profile.id,
    start_date: getStartOfMonth(),
  });
  const enrollments = data?.enrollments;

  return (
    <Stack spacing={4}>
      <EnrolledPatients patientsEnrolled={enrollments}>
        <Stack direction="row" sx={{ justifyContent: "space-between", marginRight: "40px" }}>
          <Typography variant="subtitle1">{t("earnings_widget.enrolled_patients.commission_level_1")}</Typography>
          <Typography variant="subtitle1">{t("earnings_widget.enrolled_patients.commission_level_2")}</Typography>
        </Stack>
      </EnrolledPatients>
      <TotalEarnings />
    </Stack>
  );
};
